export const SimpleBaseMixin = function (chart, props) {
  const { dimension, group } = props;

  chart.dimension(dimension).group(group);

  return chart;
};
